
import { mapGetters } from 'vuex'
export default {
 name: "TabContent",
 props: {
    id: {
      default: '',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
 },
 data() {
    return {
      startActive: this.active !== '',
    }
  },
  computed: {
    ...mapGetters({
      activeTab : 'pages/getActiveTab',
    }),
  },
}
